import { render, staticRenderFns } from "./CreditPromissoryNotes.vue?vue&type=template&id=20679e11&"
import script from "./CreditPromissoryNotes.vue?vue&type=script&lang=js&"
export * from "./CreditPromissoryNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports